import React from 'react'
import { motion } from "framer-motion";

const Privacy = () => {
    return (
        <div className="">
            <section className="privacy-terms-section py-5">
                <div className="container">

                    {/* Privacy Policy */}
                    <motion.div
                        className="policy-section mb-5"
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: false, amount: 0.3 }}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                    >
                        <h2 className="section-title">Privacy Policy</h2>
                        <p>
                            At <strong>JJ Associates</strong>, your privacy is our priority. We collect only the information essential to serve you better — such as your name, contact details, and service preferences.
                        </p>
                        <p>
                            Your personal information is used solely to enhance your experience and will never be sold or shared with third parties, except as required to provide our services (like delivery or customer support).
                        </p>
                        <p>
                            By accessing our website, you consent to the terms of this Privacy Policy.
                        </p>
                    </motion.div>

                    {/* Terms & Conditions */}
                    <motion.div
                        className="terms-section"
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: false, amount: 0.3 }}
                        transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
                    >
                        <h2 className="section-title">Terms & Conditions</h2>
                        <ul className="terms-list">

                            <p>All jewellery items sold under the <b> Tanishq </b> brand are certified for authenticity and subject to availability.</p>
                            <p>Product details, designs, and prices may vary without prior notice.</p>
                            <p>All content on this site, including images and text, is the property of <strong> JJ Associates – Tanishq Rajkot </strong>.</p>
                            <p>Any disputes shall fall under the jurisdiction of <strong> Rajkot, Gujarat </strong>.</p>
                        </ul>
                    </motion.div>

                </div>
            </section>
        </div>
    )
}

export default Privacy